import api from "../api/axios";
import { API_ENDPOINTS } from "../constants";
import { TenantStatus, Tenant, TenantApiDto, mapTenantFromApi } from "./tenantsTypes";

// Re-export from tenantsTypes to keep a single import path for consumers
export type { Tenant } from "./tenantsTypes";
export { TenantStatus, getTenantStatusKey } from "./tenantsTypes";

export interface CreateTenantParams {
  clinicName: string;
  ownerFirstName: string;
  ownerLastName: string;
  email: string;
  phoneNumber: string;
}

export interface UpdateTenantParams {
  id: string;
  clinicName?: string;
  contactName?: string;
  contactEmail?: string;
  phoneNumber?: string;
}

export interface GetTenantsParams {
  search?: string;
  status?: TenantStatus | null;
}

export interface GetTenantsResponse {
  data: Tenant[];
  total: number;
}

export const tenantsService = {
  getTenants: async (params?: GetTenantsParams): Promise<GetTenantsResponse> => {
    const response = await api.get<TenantApiDto[]>(API_ENDPOINTS.TENANTS, {
      params: {
        search: params?.search || undefined,
        status: params?.status != null ? params.status : undefined,
        start: 0,
        limit: 200,
        total: true,
      },
    });

    const data = response.data.map(mapTenantFromApi);

    return { data, total: data.length };
  },

  createTenant: async (params: CreateTenantParams): Promise<Tenant> => {
    const response = await api.post<TenantApiDto>(API_ENDPOINTS.TENANTS, {
      clinicName: params.clinicName,
      ownerFirstName: params.ownerFirstName,
      ownerLastName: params.ownerLastName,
      email: params.email,
      phoneNumber: params.phoneNumber,
    });

    return mapTenantFromApi(response.data);
  },

  updateTenant: async (params: UpdateTenantParams): Promise<Tenant> => {
    const [ownerFirstName = "", ...rest] = (params.contactName ?? "").split(" ");
    const ownerLastName = rest.join(" ");

    const response = await api.put<TenantApiDto>(
      `${API_ENDPOINTS.TENANTS}/${params.id}`,
      {
        clinicName: params.clinicName,
        ownerFirstName,
        ownerLastName,
        email: params.contactEmail,
        phoneNumber: params.phoneNumber,
      },
    );

    return mapTenantFromApi(response.data);
  },

  activateTenant: async (id: string): Promise<void> => {
    await api.put(`${API_ENDPOINTS.TENANTS}/${id}/activate`);
  },

  suspendTenant: async (id: string): Promise<void> => {
    await api.put(`${API_ENDPOINTS.TENANTS}/${id}/deactivate`);
  },

  reactivateTenant: async (id: string): Promise<void> => {
    await api.put(`${API_ENDPOINTS.TENANTS}/${id}/activate`);
  },

  restoreTenant: async (id: string): Promise<void> => {
    await api.put(`${API_ENDPOINTS.TENANTS}/${id}/activate`);
  },

};
